// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Mq-z","slideIn":"Nq-z"};